export default [
  {
    path: '/trade',
    name: 'TradeIndex',
    component: () => import('@/views/Trade/Trade.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/trade/detail/:serno',
    name: 'TradeDetail',
    props: true,
    component: () => import('@/views/Trade/Detail.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/trade/detail/:serno/share',
    name: 'TradeShare',
    props: true,
    component: () => import('@/views/Trade/Share.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/trade/share/:id/enable',
    name: 'TradeEnableSharedTrade',
    component: () => import('@/views/Trade/EnableSharedTrade.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];
